// LearnCore Frontend - 填空题渲染组件

import RichTextRenderer from './RichTextRenderer';

interface ClozeRendererProps {
  content: string;
  className?: string;
  /** 是否显示挖空，默认false（显示答案） */
  showCloze?: boolean;
  /** 是否解析HTML标签，默认true */
  parseHtml?: boolean;
  /** 是否解析Markdown语法，默认true */
  parseMarkdown?: boolean;
}

/**
 * 填空题渲染组件
 * 专门用于渲染包含填空标记的内容
 */
export default function ClozeRenderer({ 
  content, 
  className = '', 
  showCloze = false,
  parseHtml = true,
  parseMarkdown = true
}: ClozeRendererProps) {
  
  // 检查是否包含填空标记
  const hasClozeNotation = /\{\{c\d+::[^}]+\}\}/.test(content);
  
  if (!hasClozeNotation) {
    // 如果没有填空标记，直接使用普通渲染
    return (
      <RichTextRenderer 
        content={content}
        className={className}
        parseHtml={parseHtml}
        parseMarkdown={parseMarkdown}
        showCloze={false}
      />
    );
  }

  return (
    <div className={`cloze-renderer ${className}`}>
      <RichTextRenderer 
        content={content}
        parseHtml={parseHtml}
        parseMarkdown={parseMarkdown}
        showCloze={showCloze}
      />     
      
    </div>
  );
}

/**
 * 检查文本是否包含填空标记
 */
export function hasClozeNotation(text: string): boolean {
  return /\{\{c\d+::[^}]+\}\}/.test(text);
}

/**
 * 提取填空标记中的答案内容（用于TTS朗读）
 */
export function extractClozeAnswers(text: string): string {
  return text.replace(/\{\{c\d+::([^}]+)\}\}/g, '$1');
}

/**
 * 提取填空标记中的挖空内容（用于显示）
 */
export function extractClozeBlanks(text: string): string {
  return text.replace(/\{\{c\d+::[^}]+\}\}/g, '______');
}

